import { Navbar } from "@milestone/component-library";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import { NestedRoutes } from "../../../app/routes.types";
import { matchPath, useLocation } from "react-router-dom";

interface NavigationBarProps {
  routes?: NestedRoutes;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({ routes }) => {
  const getCrumbs = async (
    search: string,
    routes: NestedRoutes,
    crumbs: Array<string> = [],
    path = ""
  ) => {
    if (routes.path) path += `/${routes.path}`;
    const match = matchPath(search, {
      path: path,
      exact: false,
      strict: false,
    });
    // if the path matches that route
    if (match) {
      // use routes getName function for dynamic names or name if available
      const name = routes.getName
        ? await routes.getName(match.params)
        : routes.name;
      if (name) crumbs.push(name);
      // check children and recurse
      if (routes.children) {
        const length = crumbs.length;
        for (const route of routes.children) {
          await getCrumbs(search, route, crumbs, path);
          // break out early if new crumb added
          if (length !== crumbs.length) break;
        }
      }
    }
    return crumbs;
  };

  const profilePicture = useAppSelector(state => state.auth.profilePicture);
  const isAdmin = true;

  const location = useLocation();
  const [crumbs, setCrumbs] = useState<Array<string>>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const path = location.pathname;
    const fetchCrumbs = async () => {
      if (routes) setCrumbs(await getCrumbs(path, routes));
      setIsLoading(false);
    };
    fetchCrumbs();
  }, [location]);

  return (
    <>
      <Navbar
        crumbsLoading={isLoading}
        isLoggedIn={true}
        isAdmin={isAdmin ? true : false}
        profilePicture={profilePicture}
        crumbs={crumbs}
      />
    </>
  );
};
